export default class TablePageItems {
    current = 0;
    pages = 0;
    size = 0;
    total = 0;
}
